import sanityClient from '@sanity/client';

export default sanityClient({
  projectId: '1oxjcrqg',
  dataset: 'production',
});
